/**
 * Product template - Show text of selected color/size
 */
window.addEventListener('load', frd_product_swatches);

function frd_product_swatches() {
  if (typeof frd_product === 'undefined') {
    return;
  }
  const frd_pdp_product_handle = frd_product.handle;
  let frd_pdp_variant_id = frd_product.default_variant_id;
  const frd_pdp_color_title = document.querySelector('.selected-color-name span');
  const frd_pdp_size_title = document.querySelector('.selected-size-name span');
  const frd_pdp_variant_swatches = document.querySelectorAll('.latest-variant-option .latest-option');

  // Update initial color/size titles based on default variant
  if (frd_product.default_variant_title) {
    const defaultParts = frd_product.default_variant_title.split(' / ');
    const defaultColor = defaultParts[0] || frd_product.default_variant_title;
    const defaultSize = defaultParts[1];

    if (frd_pdp_color_title) {
      frd_pdp_color_title.innerText = defaultColor;
    }

    if (frd_pdp_size_title && defaultSize) {
      frd_pdp_size_title.innerText = defaultSize;
    }
  }

  // Loop variants
  frd_pdp_variant_swatches.forEach((frd_pdp_variant_swatch, index) => {
    // Add listener to each variant
    frd_pdp_variant_swatch.addEventListener('click', (event) => {
      // Get variant data
      fetch('/products/' + frd_pdp_product_handle + '.js').then(function(response) {
        return response.json();
      }).then(function(product) {
        const url_parameters = new URLSearchParams(window.location.search);
        frd_pdp_variant_id = parseInt(url_parameters.get('variant'));
        let frd_pdp_variant = product.variants.find(function(variant){ return variant.id === frd_pdp_variant_id });

        if(frd_pdp_variant) {
          let frd_pdp_variant_title_text = frd_pdp_variant.title;
          const parts = frd_pdp_variant_title_text.split(' / ');
          const color = parts[0] || frd_pdp_variant_title_text;
          const size = parts[1];

          // Update color text
          if (frd_pdp_color_title) {
            frd_pdp_color_title.innerHTML = color;
          }

          // Update size text
          if (frd_pdp_size_title && size) {
            frd_pdp_size_title.innerHTML = size;
          }
        }
      });
    });
  });
}
